import { render } from "./FinishAdditionalDocsPage.vue?vue&type=template&id=5840fe68&scoped=true"
import script from "./FinishAdditionalDocsPage.vue?vue&type=script&lang=js"
export * from "./FinishAdditionalDocsPage.vue?vue&type=script&lang=js"

import "./FinishAdditionalDocsPage.vue?vue&type=style&index=0&id=5840fe68&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5840fe68"]])

export default __exports__